import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_COMPROVAR } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = false;

const hiHaIdVigilant = idVigilant => idVigilant === undefined || idVigilant === null || idVigilant === '';

const idVigilant = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_COMPROVAR: {
            const { idVigilant } = action.dades;
            return hiHaIdVigilant(idVigilant);
        }

        default:
            return state;

    }
};

export default idVigilant;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/errors/idVigilant.js